// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill-base_9af3d389 {
  margin: 0 0.667rem 0.667rem 0;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1.5rem;
  height: 1.667rem;
  background-color: #eaedef;
  border: solid 0.084rem #c1c8cd;
  color: #11304d;
  border-radius: 0.167em;
  padding: 0 0.667rem;
  font-size: 0.834rem;
  font-weight: 600;
  max-width: 100%;
  position: relative;
}
.pill-base_9af3d389:last-child {
  margin-right: 0;
}
.pill-base_disabled_9af3d389 {
  cursor: default;
  background-color: #eaedef;
  border: solid 0.084rem #c1c8cd;
  color: #c1c8cd;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pill-base": `pill-base_9af3d389`,
	"pill-base_disabled": `pill-base_disabled_9af3d389`
};
export default ___CSS_LOADER_EXPORT___;
